export type MessageTypes = 'alert-danger' | 'alert-warning' | 'alert-success' | 'alert-info';

export const MESSAGE_SUCCESS = 'alert-success';
export const MESSAGE_WARNING = 'alert-warning';
export const MESSAGE_ERROR = 'alert-danger';
export const MESSAGE_INFO = 'alert-info';